import { render, staticRenderFns } from "./guestMessage.vue?vue&type=template&id=0ed7dfd0"
import script from "./guestMessage.vue?vue&type=script&lang=js"
export * from "./guestMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports